module.exports = new __parcel__URL__("Charlie_Text-Black.aa4e8124.woff2").toString();